import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
export type DividerProps = {
  className?: string;
  variant?: 'primary' | 'secondary';
};
const Divider = t0 => {
  const $ = _c(5);
  const {
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "primary" : t1;
  const t2 = variant === "primary" ? "border-solid" : "border-dashed";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cx("w-full border-0 border-b border-tertiary opacity-100", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <hr aria-orientation="horizontal" className={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default Divider;